import {createContext, useContext} from "react";
import type {RealtimeClient} from "@/api/realtime/WebSocketClient.ts";

export const RealtimeContext = createContext<RealtimeClient | null>(null);

export function useRealtime(): RealtimeClient {
    const client = useContext(RealtimeContext);
    if (!client) throw new Error("useRealtime must be used within RealtimeProvider");
    return client;
}
